import { ToteEngagementModeEnum } from '@mote/api'
import { Emoji } from '../../shared/components'

/**
 * @typedef {'initial' | 'awaiting' | 'teply' | 'response'} ToteCardMode
 */

/**
 * @type {Record<string, ToteCardMode>}
 */
export const SCREEN_MODES = {
  INITIAL: 'initial',
  AWAITING: 'awaiting',
  TEPLY: 'teply',
  RESPONSE: 'response'
}

export const ACTION_DATA = {
  [ToteEngagementModeEnum.AFFIRMATIVE]: {
    icon: (
      <Emoji label='Thumbs up' emojiSize={24} fontSize={14} noTooltip>
        👍
      </Emoji>
    ),
    text: 'I know what to do'
  },
  [ToteEngagementModeEnum.ASSISTIVE]: {
    icon: (
      <Emoji label='SOS' emojiSize={24} fontSize={14} noTooltip>
        🆘
      </Emoji>
    ),
    text: 'I may need help'
  },
  [SCREEN_MODES.AWAITING]: {
    icon: (
      <Emoji label='Hourglass' emojiSize={24} fontSize={14} noTooltip>
        ⏳
      </Emoji>
    ),
    text: 'Awaiting response'
  }
}
